import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TEasFeeApi } from './types';

export const easFee: TEasFeeApi = {
	getAnnualFeeTypeOptions: () =>
		http.get(endpoint.easFee.ANNUAL_FEE_TYPE_OPTIONS).then((response) => response.data),
	getAnnualFeeTypeList: (payload) =>
		http.post(endpoint.easFee.ANNUAL_FEE_TYPE_LIST, payload).then((response) => response.data),
	getAnnualFeeTypeDetails: (payload) =>
		http.get(endpoint.easFee.ANNUAL_FEE_TYPE_DETAILS(payload.id)).then((response) => response.data),
	createAnnualFeeType: (payload) =>
		http.post(endpoint.easFee.ANNUAL_FEE_TYPE_CREATE, payload).then((response) => response.data),
	updateAnnualFeeType: (payload) =>
		http
			.put(endpoint.easFee.ANNUAL_FEE_TYPE_UPDATE(payload.id), payload.body)
			.then((response) => response.data),
	deleteAnnualFeeType: (payload) =>
		http
			.delete(endpoint.easFee.ANNUAL_FEE_TYPE_DELETE(payload.id))
			.then((response) => response.data),

	getMonthlyFeeOptions: () =>
		http.get(endpoint.easFee.MONTHLY_FEE_OPTIONS).then((response) => response.data),
	getMonthlyFeeList: (payload) =>
		http.post(endpoint.easFee.MONTHLY_FEE_LIST, payload).then((response) => response.data),
	getMonthlyFeeDetails: (payload) =>
		http.get(endpoint.easFee.MONTHLY_FEE_DETAILS(payload.id)).then((response) => response.data),
	createMonthlyFee: (payload) =>
		http.post(endpoint.easFee.MONTHLY_FEE_CREATE, payload).then((response) => response.data),
	updateMonthlyFee: (payload) =>
		http
			.put(endpoint.easFee.MONTHLY_FEE_UPDATE(payload.id), payload.body)
			.then((response) => response.data),
	deleteMonthlyFee: (payload) =>
		http.delete(endpoint.easFee.MONTHLY_FEE_DELETE(payload.id)).then((response) => response.data),

	getInvoicingFeeTypeOptions: () =>
		http.get(endpoint.easFee.INVOICING_FEE_TYPE_OPTIONS).then((response) => response.data),
	getInvoicingFeeTypeList: (payload) =>
		http.post(endpoint.easFee.INVOICING_FEE_TYPE_LIST, payload).then((response) => response.data),
	getInvoicingFeeTypeDetails: (payload) =>
		http
			.get(endpoint.easFee.INVOICING_FEE_TYPE_DETAILS(payload.id))
			.then((response) => response.data),
	createInvoicingFeeType: (payload) =>
		http.post(endpoint.easFee.INVOICING_FEE_TYPE_CREATE, payload).then((response) => response.data),
	updateInvoicingFeeType: (payload) =>
		http
			.put(endpoint.easFee.INVOICING_FEE_TYPE_UPDATE(payload.id), payload.body)
			.then((response) => response.data),

	getFeeClassOptions: () =>
		http.get(endpoint.easFee.FEE_CLASS_OPTIONS).then((response) => response.data),
	getFeeClassList: (payload) =>
		http.post(endpoint.easFee.FEE_CLASS_LIST, payload).then((response) => response.data),
	getFeeClassDetails: (payload) =>
		http.get(endpoint.easFee.FEE_CLASS_DETAILS(payload.id)).then((response) => response.data),
	createFeeClass: (payload) =>
		http.post(endpoint.easFee.FEE_CLASS_CREATE, payload).then((response) => response.data),
	updateFeeClass: (payload) =>
		http
			.put(endpoint.easFee.FEE_CLASS_UPDATE(payload.id), payload.body)
			.then((response) => response.data),
	deleteFeeClass: (payload) =>
		http.delete(endpoint.easFee.FEE_CLASS_DELETE(payload.id)).then((response) => response.data),
};
